import axios from 'axios';

const list = (data) => axios.get('/pro/quarter/list', data);
const save = (data) => axios.post('/pro/quarter/save', data);
const del = (data) => axios.post('/pro/quarter/delete', data);


export default {
  list,
  save,
  del,

}


